import { LogsService } from "../api/service";

export const useLogs = () => {
  const getIvideonLogs = LogsService.GET.getIvideonLogs;
  const getIvideonEventTypes = LogsService.GET.getIvideonEventTypes;
  const getIvideonLogsFileHash = LogsService.GET.getIvideonLogsFileHash;
  const getLogsNames = LogsService.GET.getLogsNames;
  const getLogsCron = LogsService.GET.getLogsCron;

  return {
    getIvideonLogs,
    getIvideonEventTypes,
    getIvideonLogsFileHash,
    getLogsNames,
    getLogsCron,
  };
};
